module.exports = __webpack_public_path__ + "img/25.0bf31129.jpg";